// function flattenAndConcatenate(obj, prefix = '') {
//     let parts = [];
//     for (const key in obj) {
//         if (Object.prototype.hasOwnProperty.call(obj, key)) {
//             const currentKey = prefix ? `${prefix}.${key}` : key;
//             const value = obj[key];

//             if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
//                 parts.push(flattenAndConcatenate(value, currentKey)); // Recurse for nested objects
//             } else if (Array.isArray(value)) {
//                 // Handle arrays: join elements with a comma or specific separator
//                 parts.push(`${currentKey}: ${value.join(', ')}`);
//             } else {
//                 // Handle primitive values
//                 parts.push(`${currentKey}: ${value}`);
//             }
//         }
//     }
//     return parts.join('. '); // Join all parts with a period and space
// }

function removeNonStringAttributes(obj) {
    for (const key in obj) {
        // Ensure it's an own property, not from the prototype chain
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (typeof obj[key] !== 'string') {
                delete obj[key];
            }
        }
    }
    return obj;
}

function getStringBetween(fullString, startString, endString) {
    if (!fullString) return ''
    const startIndex = fullString.indexOf(startString);

    // If startString is not found, return null
    if (startIndex === -1) {
        return null;
    }

    // Calculate the actual starting position of the desired string
    const startOfResult = startIndex + startString.length;

    const endIndex = fullString.indexOf(endString, startOfResult);

    // If endString is not found after the startString, return null
    if (endIndex === -1) {
        return null;
    }

    // Extract the substring between the start and end points
    return fullString.substring(startOfResult, endIndex);
}

function camelToSnakeCase(camelCaseString) {
    return camelCaseString.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1_$2').toLowerCase();
}


export {
    camelToSnakeCase,
    // flattenAndConcatenate,
    removeNonStringAttributes,
    getStringBetween
}